import React, { Component } from 'react';
import ReactIdSwiper from 'react-id-swiper';
import swiperParamsPodcast from './swiperParamsPodcast';
import 'swiper/dist/css/swiper.min.css';

class CustomSwiperPodcast extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nextEl: null,
      prevEl: null,
      prevArrowVisible: false,
      nextArrowVisible: true,
    };
  }

  getSwiperRef = e => {
    if (e.pagination.bullets != null) {
      e.on('slideChange', () => {
        const maxSwipeValue = e.pagination.bullets.length - 1;
        if (e.snapIndex === 0) this.setState({ prevArrowVisible: false, nextArrowVisible: true });
        else if (e.snapIndex === maxSwipeValue) this.setState({ nextArrowVisible: false, prevArrowVisible: true });
        else this.setState({ prevArrowVisible: true, nextArrowVisible: true });
      });
    }

    this.setState({ nextEl: e.navigation.nextEl, prevEl: e.navigation.prevEl });
  };

  render() {
    return (
      <div className="section-swiper news-swiper">
        <ReactIdSwiper getSwiper={e => e != null && this.getSwiperRef(e)} {...swiperParamsPodcast}>
          {this.props.children}
        </ReactIdSwiper>
        {this.state.prevArrowVisible && (
          <div onClick={() => this.state.prevEl.click()} className="swiper-navigation-prev">
            <i className="fas fa-chevron-left"></i>
          </div>
        )}
        {this.state.nextArrowVisible && (
          <div onClick={() => this.state.nextEl.click()} className="swiper-navigation-next">
            <i className="fas fa-chevron-right"></i>
          </div>
        )}
      </div>
    );
  }
}

export default CustomSwiperPodcast;
